import axios, { AxiosResponse } from "axios";

export const instanceV2 = axios.create({
  // baseURL: `https://dev-aggregator.kibble.exchange`,
  // baseURL: `http://192.168.0.111:4001`,
  baseURL: `https://aggregator.kibble.exchange`,
  headers: {
    Accept: "application/json",
  },
});

instanceV2.interceptors.request.use(
  async (config) => {
    //@ts-ignore
    config.headers = {
      ...config.headers,
    };
    const token = localStorage.getItem("TOKEN");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instanceV2.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  function (error) {
    if (error.response) {
      return Promise.reject({
        error: error?.response,
        status: error.response.status,
        message: error.response.data.message,
      });
    } else if (error.request) {
      return Promise.reject(error.request);
    } else {
      return Promise.reject(error);
    }
  }
);
